import type { HomeWidgetsPriority } from './types';

export const MAX_HOME_WIDGETS = 6;

export const HOME_WIDGETS_PRIORITY: HomeWidgetsPriority = {
  Coinback: 3,
  Message: 7,
  Offer: 6,
  Quest: 10,
  Tournament: 0,
  UnclaimedFreeSpin: 4,
  UpcomingDailyMission: 5,
  MetaGameEvent: 0,
  SnappyGift: 8,
  CrownRoad: 2,
  MonetizationEvent: 2,
  Challenge: 1,
  UpcomingMission: 5,
};
